export class Collector<T> {
  static from<S>(things: S[]): S[] {
    const collector = new Collector<S>();
    for (const thing of things) {
      collector.add(thing);
    }
    return collector.collect();
  }

  private collected: T[];

  constructor() {
    this.collected = [];
  }

  add(thing: T | T[]): void {
    if (Array.isArray(thing)) {
      this.collected.push(...thing);
    } else {
      this.collected.push(thing);
    }
  }

  collect(): T[] {
    return [...this.collected];
  }
}
